/* eslint-disable @typescript-eslint/no-explicit-any */
import { PageTypeSuffix } from '@/constants'
import { useNotification } from '@/containers'
import type { Category } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { useRouter } from 'next/router'
import ImageOptimize from '../ImageOptimize'

interface ChildrenCategoryType {
  data: Category[]
}
export const ChildrenCategory = ({ data }: ChildrenCategoryType) => {
  const router = useRouter()
  const { systemConfig } = useNotification()
  return (
    <div
      className={`pb-2 mb-1 flex overflow-x-auto hiddenScrollBar scrollBarXCS scroll-smooth`}
    >
      {data &&
        data.map((e, i) => {
          return (
            <div
              className='item flex flex-[0_0_100px] max-w-[100px] flex-wrap justify-center px-2 cursor-pointer'
              key={i}
              onClick={() =>
                router.push(
                  getTranslate(e?.slugs?.value) + PageTypeSuffix.CATEGORY
                )
              }
            >
              <ImageOptimize
                src={
                  e.image ||
                  systemConfig?.imagePlaceholder ||
                  process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER ||
                  ''
                }
                alt={getTranslate(e.name)}
                className='h-[60px] w-[60px] rounded-lg object-contain'
              />
              <span className='mt-2 h-9 w-full text-center text-sm leading-[18px] text-gray-800 line-camp-2 text-ellipsis overflow-hidden'>
                {getTranslate(e.name)}
              </span>
            </div>
          )
        })}
    </div>
  )
}
